module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-left-arrow-gray-dark-on-white-710e4e80adaa2003cf1a778656147af9.svg";